"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_basic_ui_1 = require("@xenodrive/vue-basic-ui");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BssMovementToggleListButton',
    props: {
        "modelValue": { type: Boolean },
        "modelModifiers": {},
    },
    emits: ["update:modelValue"],
    setup(__props) {
        const active = (0, vue_1.useModel)(__props, "modelValue");
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_basic_ui_1.Button), {
                class: (0, vue_2.normalizeClass)(["the-menu-icon", { active: active.value }]),
                "icon-size": "1.75rem",
                icon: "fa:bars",
                onClick: _cache[0] || (_cache[0] = ($event) => (active.value = !active.value))
            }, null, 8, ["class"]));
        };
    }
});
